import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// if (location.protocol !== "https:") {
//   location.protocol = "https:";
// }

createApp(App).use(store).use(router).mount("#app");
